import React, { useContext, useEffect, useState } from 'react'
import styles from './LbFormsManager.module.css'
import { FaCopy, FaTrash, FaFilter, FaEye } from 'react-icons/fa'
import { motion } from 'framer-motion'
import { BASE_URL_API } from '../../../References/URLs'
import AuthContext from '../../../store/auth-context'
import ActiveStoreContext from '../../../store/ActiveStoreContext'
import { Link } from 'react-router'

const LbFormsManager = () => {
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext);
    const vendorIdentifier = JSON.parse(authCtx?.loginData)?.partnersData?.vendorIdentifier
    const activeStore = (() => { try { return (asCtx?.activeStore && asCtx.activeStore.trim() !== "") ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();

    const [forms, setForms] = useState([{
        id: 'f1',
        domain: 'www.client.com',
        formIdentifier: 'contact_form',
        token: 'eyJmb3JtSWQiOiAiY29udGFjdF9mb3JtIn0=',
        pageURL: 'https://www.client.com/contact',
        createdOn: '2024-07-15',
    },
    {
        id: 'f2',
        domain: 'academy.client.com',
        formIdentifier: 'appointment_form',
        token: 'eyJmb3JtSWQiOiAiYXBwb2ludG1lbnRfZm9ybSJ9',
        pageURL: '',
        createdOn: '2024-07-20',
    },
    {
        id: 'f3',
        domain: 'store.client.com',
        formIdentifier: 'feedback_form',
        token: 'eyJmb3JtSWQiOiAiZmVlZGJhY2tfZm9ybSJ9',
        pageURL: 'https://store.client.com/feedback',
        createdOn: '2024-08-01',
    }])

    const [filterDomain, setFilterDomain] = useState('')
    const [copiedTokenId, setCopiedTokenId] = useState(null)
    const uniqueDomains = [...new Set(forms?.map(form => form?.domainIdentifier))]

    const lb_getAllForms = async () => {
        const response = await fetch(BASE_URL_API + "lb_getAllForms",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    vendorIdentifier: vendorIdentifier,
                    storeIdentifier: activeStore.storeIdentifier
                })
            });

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo?.status === "success") {
                setForms(respo?.response)
            } else {
                if (respo?.message === "tokenExpired") {
                    authCtx.logout()
                }
            }
            console.log(respo)
        }
    }

    const handleCopyToken = (token, id) => {
        navigator.clipboard.writeText(token)
        setCopiedTokenId(id)
        setTimeout(() => setCopiedTokenId(null), 2000)
    }

    const filteredForms = filterDomain
        ? forms?.filter(form => form.domainIdentifier === filterDomain)
        : forms

    useEffect(() => {
        lb_getAllForms()
    }, [])



    return (
        <div className={styles.formsContainer}>
            <div className={styles.header}>
                <h2>Forms Manager</h2>
                <div className={styles.filter}>
                    <FaFilter />
                    <select value={filterDomain} onChange={(e) => setFilterDomain(e.target.value)}>
                        <option value="">All Domains</option>
                        {uniqueDomains?.map((domain, idx) => (
                            <option key={idx} value={domain}>{domain}</option>
                        ))}
                    </select>
                </div>
            </div>

            <div className={styles.formsList}>
                {filteredForms?.map(form => (
                    <motion.div
                        key={form?.id}
                        className={styles.formCard}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                    >
                        <Link to={`/leadbridge/forms/${form?.formIdentifier}`} className={styles.details}>
                            <h4>{form?.formIdentifier}</h4>
                            <p><strong>Name:</strong> {form?.formName}</p>
                            <p>
                                <Link to={`/view-token/${form?.formIdentifier}`}>
                                    <strong>Token:</strong> <code></code>
                                    <div>
                                        View
                                    </div>

                                </Link>
                            </p>
                            <p><strong>Created:</strong> {form?.createdOn}</p>
                        </Link>
                        <Link to={`/leadbridge/view-token/${form?.formIdentifier}`} className={styles.tokenIcon}>
                            <FaEye /> View Token 
                        </Link>
                    </motion.div>
                ))}
                {filteredForms?.length === 0 && <p className={styles.empty}>No forms found for selected domain.</p>}
            </div>
        </div>
    )
}

export default LbFormsManager
